import {
  Avatar,
  createPersonAvatarProps,
  Typography,
  XStack,
} from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

interface MobileDrawerProfileFooterProps {
  name: string;
  uuid: string;
}

export const MobileDrawerProfileFooter: React.FC<
  MobileDrawerProfileFooterProps
> = ({ name, uuid }) => {
  const theme = useTheme();

  return (
    <XStack alignItems="center" gap={theme.sk.spacing.spaceSMedium}>
      <Avatar {...createPersonAvatarProps(name, uuid)} size="$md" />
      <Typography
        color="$textPrimary"
        flex={1}
        fontWeight="$medium"
        numberOfLines={1}
        size="$md"
      >
        {name}
      </Typography>
    </XStack>
  );
};
